import { render } from "./AddTabContent.vue?vue&type=template&id=c265db00&scoped=true"
import script from "./AddTabContent.vue?vue&type=script&lang=js"
export * from "./AddTabContent.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3194113096/src/coop-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c265db00"]])

export default __exports__